import { CONSTANTS } from "../constants";
import { isPlatform } from "@ionic/react";
import { NativeAudio } from "@ionic-native/native-audio";

let currentAudioTrack: string = "";
let path = CONSTANTS.ALERT_RINGTONE.ALERT;
let audioAsset: any = new Audio(path);
let nativeAudio = NativeAudio;

const preload = (audioTrack: any) => {
  if (isPlatform("ios") || isPlatform("android")) {
    nativeAudio.unload("trackID").then(
      () => {},
      (err) => err
    );
    nativeAudio.preloadComplex(audioTrack, path, 1, 1, 0).then(
      () => {},
      (err) => err
    );
  }
};

const play = (audioTrack: any) => {
  if (isPlatform("ios") || isPlatform("android")) {
    nativeAudio.play(audioTrack).then(
      () => {},
      (err) => err
    );
    nativeAudio.loop(audioTrack).then(
      () => {},
      (err) => err
    );
  } else {
    audioAsset.load();
    audioAsset.loop = true;
    audioAsset.play();
  }
};

const stop = (audioTrack: any) => {
  if (isPlatform("ios") || isPlatform("android")) {
    nativeAudio.stop(audioTrack);
  } else {
    audioAsset.pause();
  }
};

export const SmartAudioService = {
  preload,
  currentAudioTrack,
  play,
  stop,
};
